'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _Company = require('../Company');

var _OptionTypeSwitcher = require('./OptionTypeSwitcher.scss');var styles = _interopRequireWildcard(_OptionTypeSwitcher);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OptionTypeSwitcher = function OptionTypeSwitcher(props) {var
  title = props.title,hasPropertiesForSale = props.hasPropertiesForSale,hasPropertiesForRent = props.hasPropertiesForRent;

  var renderOptionTypeButton = function renderOptionTypeButton(optionType) {var _cx;return (
      _react2.default.createElement('button', {
          className: (0, _classnames2.default)(
          styles.optionTypeButton, (_cx = {}, _cx[
          styles.activeButton] = props.activeOption === optionType, _cx)),

          onClick: props.handleSelectOption,
          value: optionType },

        props.translate(optionType)));};



  var separator = hasPropertiesForSale && hasPropertiesForRent ?
  _react2.default.createElement('span', { className: styles.separator }) :
  '';

  return (
    _react2.default.createElement('div', { className: styles.optionTypeSwitcher },
      _react2.default.createElement('div', null, title, '\xA0'),
      hasPropertiesForSale && renderOptionTypeButton(_Company.OPTION_TYPES_COMPANY.SALE),
      separator,
      hasPropertiesForRent && renderOptionTypeButton(_Company.OPTION_TYPES_COMPANY.RENT)));


}; // styles

OptionTypeSwitcher.propTypes = {
  translate: _propTypes2.default.func,
  title: _propTypes2.default.string,
  activeOption: _propTypes2.default.string,
  hasPropertiesForSale: _propTypes2.default.bool,
  hasPropertiesForRent: _propTypes2.default.bool,
  handleSelectOption: _propTypes2.default.func,
  className: _propTypes2.default.string };exports.default =


OptionTypeSwitcher;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/OptionTypeSwitcher/OptionTypeSwitcher.js
// module id = 1193
// module chunks = 0